import React from 'react';
import cx from 'classnames';
import styles from './Tabs.module.scss';
import { useTranslation } from 'react-i18next';

const Tabs = ({ state, onClick, isHideTeam }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.tabs}>
      <div
        className={cx(styles.tab, { [styles.tabActive]: !state?.folders && !state?.team })}
        onClick={() => onClick({ folders: false, team: false })}
      >
        {t('dashboard.videos.title')}
      </div>
      <div className={cx(styles.tab, { [styles.tabActive]: state?.folders })} onClick={() => onClick({ folders: true })}>
        {t('dashboard.folders.title')}
      </div>
      {!isHideTeam && (
        <div className={cx(styles.tab, { [styles.tabActive]: state?.team })} onClick={() => onClick({ team: true })}>
          {t('dashboard.tab.team')}
        </div>
      )}
    </div>
  );
};

export default Tabs;
